/**
 * Queue Jobs Interfaces
 */

export interface QueueJob {
  id: number;
  job_id: string;
  phase_1: string;
  phase_2: string;
  validation_status: string;
  inserted_status: string;
}

export interface QueueJobsListQuery {
  program_id: number;
  page?: number;
  page_size?: number;
}

export interface QueueJobsPaginationMeta {
  page: number;
  page_size: number;
  total_count: number;
  total_pages: number;
  has_next: boolean;
  has_previous: boolean;
}

export interface QueueJobsListData {
  data: QueueJob[];
  meta?: {
    pagination?: QueueJobsPaginationMeta;
  };
}
